import {
  ClipboardList, BarChart3, Car, UtensilsCrossed, Gift, Mail, Briefcase,
  CalendarCheck, Sparkles, Calculator, Star,
} from "lucide-react";

const GROUPS = [
  {
    title: "Rund um den Einsatz",
    items: [
      { id: "inquiries", label: "Anfragen", hint: "Von der Website eingegangen", icon: ClipboardList },
      { id: "einsatzplan", label: "Einsatzplan", hint: "Geplante Tage bestätigen lassen — ohne Preise", icon: CalendarCheck },
      { id: "karteien", label: "Veranstaltungs-Kartei", hint: "Einkauf, Mitnehmen, To-dos und Bilder je Veranstaltung", icon: ClipboardList },
      { id: "kalkulation", label: "Kalkulation", hint: "Wareneinsatz, Fixkosten, Preis pro Person", icon: Calculator },
    ],
  },
  {
    title: "Gäste & Gestaltung",
    items: [
      { id: "event-seiten", label: "Event-Seite", hint: "Gästeseite mit Countdown, Menü und Ablauf", icon: Sparkles },
      { id: "menuekarten", label: "Menükarten", hint: "Karten gestalten und drucken", icon: UtensilsCrossed },
      { id: "bewertungen", label: "Bewertungen", hint: "Google-Bewertungen für die Startseite", icon: Star },
    ],
  },
  {
    title: "Zahlen & Weiteres",
    items: [
      { id: "stats", label: "Statistik", hint: "Umsatz und Auslastung", icon: BarChart3 },
      { id: "mileage", label: "Fahrten", hint: "Fahrtenbuch für die Steuer", icon: Car },
      { id: "vouchers", label: "Gutscheine", hint: "Verkaufen und einlösen", icon: Gift },
      { id: "vermittlung", label: "Vermittlung", hint: "Köche, Jobs, Anfragen", icon: Briefcase },
    ],
  },
];

export default function MehrTab({ onOpenTab, counts = {} }) {
  return (
    <div data-testid="mehr-tab" className="space-y-10">
      {GROUPS.map((g) => (
        <div key={g.title}>
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#BA6D52] mb-4">{g.title}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
            {g.items.map((it) => {
              const Icon = it.icon;
              return (
                <button
                  key={it.id}
                  onClick={() => onOpenTab(it.id)}
                  data-testid={`mehr-open-${it.id}`}
                  className="group text-left border border-[#E3DECE] bg-white hover:border-[#BA6D52] hover:bg-[#FAF5F1] p-5 transition-colors"
                >
                  <div className="flex items-start justify-between gap-3">
                    <Icon size={20} className="text-[#BA6D52]" />
                    {counts[it.id] > 0 && (
                      <span className="text-[10px] uppercase tracking-[0.15em] text-[#BA6D52] border border-[#BA6D52] px-2 py-0.5">
                        {counts[it.id]}
                      </span>
                    )}
                  </div>
                  <p className="font-serif text-lg text-[#2C2A26] mt-3">{it.label}</p>
                  <p className="text-xs text-[#757067] mt-1">{it.hint}</p>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
